module.exports = __webpack_public_path__ + "static/media/SaaSbg3.6d082249.png";